const doRetry = (action, onError, maxCount, currentCount, errorRetryPattern) => {
  return action().catch(error => {
    if (currentCount < maxCount) {
      onError({
        error,
        isFatal: false,
        maxCount,
        currentCount
      })

      const errorMsg = error.message || JSON.stringify(error)

      // if no specific pattern, or error msg is match given pattern, then retry
      if (!errorRetryPattern || errorRetryPattern.test(errorMsg)) {
        return doRetry(action, onError, maxCount, currentCount + 1, errorRetryPattern)
      }

      throw error
    } else {
      throw error
    }
  })
}

const retry = (action, onError, maxCount = 3, errorRetryPattern) => {
  return doRetry(action, onError, maxCount, 1, errorRetryPattern)
}


export default retry